module.exports = __webpack_public_path__ + "static/img/fingerpost_order_4.6d6f80d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fingerpost/fingerpost_order_4.jpg
// module id = 5kO/
// module chunks = 0